import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { HlsPlayer } from '@/components/ui/Video/HlsPlayer';
import { propStr } from '../../../helpers/custom-prop-types';
import Modal from './index';
const WrapVideoContentModal = (props) => {
    const { modalType, src } = props;
    return (_jsx(Modal, Object.assign({ hideRemove: true, modalClass: 'is-video', modalType: modalType, propHide: false }, { children: _jsx(HlsPlayer, { src: src }) })));
};
WrapVideoContentModal.propTypes = {
    modalType: propStr().isRequired,
    src: propStr(),
};
WrapVideoContentModal.defaultProps = {
    src: '',
};
export default WrapVideoContentModal;
